import { cn } from '@/lib/utils';
import { AgentAvatar } from './AgentAvatar';

interface AgentThinkingProps {
  message?: string;
  subMessage?: string;
  className?: string;
}

export function AgentThinking({ message = "Thinking...", subMessage, className }: AgentThinkingProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-4 py-8', className)}>
      <AgentAvatar size="lg" isThinking />
      
      <div className="flex flex-col items-center gap-2">
        <p className="text-foreground font-medium">{message}</p>
        {subMessage && (
          <p className="text-muted-foreground text-sm">{subMessage}</p>
        )}
        
        {/* Animated dots */}
        <div className="flex gap-1.5">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-primary"
              style={{
                animation: 'bounce 1s infinite',
                animationDelay: `${i * 0.15}s`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
